import { useState, useMemo, useEffect, useRef } from "react";

import { Badge, Row, Col, Form, Modal, Button, Tab, Tabs, Table } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass, } from '@fortawesome/free-solid-svg-icons';

import dwnld from '../../assets/images/dwnld.svg';
import Download_all_icon from '../../assets/images/Download_all_icon.svg';
import dlt from "../../assets/images/dlt.png";
import { ReactComponent as DltIcon } from "../../assets/images/icon_svg/delete_blue.svg";
import uplod_Vector from '../../assets/images/uplod_Vector.svg';
import { CallApi } from "./CommonFunctions";
import { toast } from "react-toastify";
import { DELETEATTACHMENTS, DOWNLOADFILES, SAVEATTACHMENTS } from "../../Utils/conts";
import { withRFSToken } from "../../Services/axios";
import { saveAs } from "file-saver";
import ConfModal from "./ConfModal";
import '../../assets/css/global/attachment/attachment.scss'
import { DownloadAllImage, DownloadImage } from "./DownloadImage";

const Attachment = ({ propData, submitData, onReload }) => {
    console.log('submitData', submitData);

    const fileInputRef = useRef(null);
    const [selectedRows, setSelectedRows] = useState([]);
    const [modalConf, setModalConf] = useState(false);
    const [selectedDelFile, setSelectedDelFile] = useState({
        index: null,
        id: null,
    });

    const handleBrowseFiles = (e) => {
        if (e) {
            e.preventDefault();
        }
        fileInputRef.current.click();
    };

    const handleFileChange = (e) => {
        const selectedFiles = Array.from(e.target.files);
        const filesWithBase64 = [];
        const allBase64 = [];
        selectedFiles.forEach((file) => {
            const reader = new FileReader();
            reader.onloadend = async () => {
                if (file.size > 26214400) {
                    toast.error(`${file.name} is too large. Maximum file size is 25MB.`);
                    return;
                }
                filesWithBase64.push({ file, base64: reader.result });
                allBase64.push({ base64: reader.result, file_name: file.name }); // for file name
                if (filesWithBase64.length === selectedFiles.length) {
                    CallApi({
                        endPoint: SAVEATTACHMENTS,
                        payload: { attachable_id: submitData?.id, attachable_type: submitData?.attType, files: allBase64 },
                        onSuccess: (res) => {
                            const innerData = res.data.response_data;
                            if (res.data.response_code === 200) {
                                toast.success(res.data.response_msg);
                                onReload()
                            } else {
                                toast.error(res.data.response_msg);
                            }

                        },
                        onError: (msg) => toast.error(msg)
                    });

                }
            };
            reader.readAsDataURL(file);
        });
        if (fileInputRef.current) {
            fileInputRef.current.value = null;
        }
    };

    const multipleDownload = async () => {
        const payload = {
            ...submitData?.dload,
            attachments: propData
        };

        const res = await withRFSToken.post(DOWNLOADFILES, payload,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                },
                responseType: 'blob', // important for handling binary file download like Excel
            }
        ).then(response => {
            const blob = new Blob([response.data], { type: response.headers['content-type'] });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = 'attachments.zip';
            document.body.appendChild(a);
            a.click();
            a.remove();
            toast.success("Downloaded Successfully");
        });
    };

    function extractPath(url) {
        try {
            let urlObject = new URL(url);
            let path = urlObject.pathname.substring(1);
            return path;
        } catch (error) {
            console.error("Invalid URL:", error);
            return null;
        }
    };

    const handleDeleteImage = (index, id, type) => {
        setSelectedDelFile({ index, id, type });
        setModalConf(true);
    };

    const handleConfDelete = () => {
        let payLoad = {attachment_ids: [{ attachment_id: selectedDelFile.id, attachment_type: 'O' }]};
        if(submitData?.service_recovery_id) {
            payLoad = {attachment_ids: [{ attachment_id: selectedDelFile.id, attachment_type: 'O' }], service_recovery_id: submitData?.service_recovery_id}
        }
        CallApi({
            endPoint: submitData?.endPoint || DELETEATTACHMENTS,
            payload: payLoad,
            onSuccess: (res) => {
                const innerData = res.data.response_data;
                if (res.data.response_code === 200) {
                    toast.success(res.data.response_msg)
                    onReload()
                    setModalConf(false);
                } else {
                    toast.error(res.data.response_msg)
                }
            },
            onError: (msg) => toast.error(msg)
        });
    }

    const confModalClose = () => {
        setModalConf(false)
        setSelectedDelFile({
            index: null,
            id: null,
        })
    }
    const downloadAll = () => {
        const rows = propData?.attachments.map(a => ({attachment_id: a.id, attachment_type: a.attachment_type}))
        DownloadAllImage({ attachments: rows, service_recovery_id: submitData?.id }, `Case Attachments (${propData?.master_airway_bill_prefix}-${propData?.master_airway_bill_no})`)
    }

    return (
        <>
            {modalConf &&
                <ConfModal
                    header={`Delete File`}
                    subHeader={`Are you sure you want to delete the file?`}
                    modalConf={() => handleConfDelete()}
                    closeModal={confModalClose}
                    primaryBtn='Delete'
                    secondaryBtn='Cancel'
                />
            }
            <div className='attchmnt_hdr'>
                <div className='d-flex'>
                    <Button variant="" className='upld_file_btn' onClick={handleBrowseFiles}> <img src={uplod_Vector} alt='uplod_Vector' /> Upload file</Button>
                    <input
                        type="file"
                        ref={fileInputRef}
                        style={{ display: "none" }}
                        // accept="image/png,image/jpeg,image/jpg,application/pdf/xlsx/docx/msg/eml"
                        accept=".pdf,.xlsx,.docx,.eml,.msg,.jpg,.jpeg,.png"
                        onChange={handleFileChange}
                        multiple
                    />
                    {/* <div className="file-search">
                        <FontAwesomeIcon icon={faMagnifyingGlass} className='search-icon' />
                        <Form.Control
                            type="text"
                            placeholder="Search File Name"
                            className="search-input"
                        />
                    </div> */}
                </div>
                <div className="gallery_download">
                    <Button
                        variant="link"
                        disabled={propData?.attachments?.length == 0}
                        onClick={downloadAll}
                    >
                        <img src={Download_all_icon} /> <span>Download All </span>
                    </Button>
                </div>
            </div>
            <Table className='attch_table message_scroll'>
                <thead>
                    <tr>
                        <th className="tw-5"></th>
                        <th className="tw-20">File Name</th>
                        <th className="tw-50">Uploaded by</th>
                        <th className="tw-20">Uploaded On</th>
                        <th className="tw-5">Action</th>
                    </tr>
                </thead>
                <tbody>
                    {propData?.attachments?.length ? propData?.attachments?.map((file, index) => (
                        <tr key={`img_index`}>
                            <td className='text-center'><img src={dwnld} className='dwnld_icon' onClick={() => DownloadImage(file.file_path, file.file_name)} /></td>
                            <td><h6>{file?.file_name}</h6><p>{file?.file_size}</p></td>
                            <td><h6>{file?.uploaded_by_org_name}</h6><p>{file?.modified_email ?? file?.uploaded_by_org_email}</p></td>
                            {/* <td><p>{file?.upload_time.split(' ')[0] + ' ' + file?.upload_time.split(' ')[1].substring(0, 5)}</p></td> */}
                            <td className='opload_on'><p>{file?.upload_time.slice(0, 16)}</p></td>
                            <td><DltIcon onClick={() => handleDeleteImage(index, file.id, file.attachment_type)} /></td>
                        </tr>
                    ))
                        :
                        <></>
                    }

                    {/* <tr>
                        <td className='text-center'><img src={dwnld} className='dwnld_icon' /></td>
                        <td><h6>Proof of Delivery</h6><p>177.03 KB</p></td>
                        <td><h6>User Cargohub 1</h6><p>user.cargohub1@cargohub.nl</p></td>
                        <td><p>12:00 18/02/2026</p></td>
                        <td><img src={dlt} alt='dlt' /></td>
                    </tr> */}
                </tbody>
            </Table>
        </>
    )
}

export default Attachment;